module.exports = __webpack_public_path__ + "img/app-store.411015e3.png";